export default __webpack_public_path__ + "864f8070c877144218f791b0ec89644c.png";